import {ToastOptions} from 'react-toastify'

export const toastDefaultConfig: ToastOptions = {
  position: 'bottom-right',
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: false,
  draggable: false,
  progressStyle: {background: '#888E00'},
}

export const toastInfiniteConfig: ToastOptions = {
  position: 'bottom-right',
  autoClose: false,
  hideProgressBar: true,
  closeOnClick: false,
  rtl: false,
  pauseOnFocusLoss: false,
  draggable: false,
  pauseOnHover: false,
}

/**
 * For a toast the user has to *act on* rather than just notice: a tool's failure message they need
 * to read carefully and usually copy into a bug report, or a body with a link in it.
 *
 * Still auto-closes — an unattended toast should clear itself — but the three settings below work
 * together, and the 3s default defeats all of them:
 *
 * - `autoClose` is long enough to notice, read and reach for. Three seconds is not, and the exit
 *   animation collapses the toast's height to zero, so even a click that starts in time can land
 *   past the element.
 * - `pauseOnHover` holds the toast open for as long as the pointer is on it. This is what makes the
 *   8s a floor rather than a deadline: reading or selecting keeps it alive indefinitely, and the
 *   countdown only resumes once the pointer leaves.
 * - `closeOnClick` is off, because selecting text *is* a click — it would tear the toast down as
 *   the selection drag ends, leaving nothing to copy.
 */
export const toastActionableConfig: ToastOptions = {
  position: 'bottom-right',
  autoClose: 8000,
  hideProgressBar: true,
  closeOnClick: false,
  rtl: false,
  pauseOnFocusLoss: false,
  pauseOnHover: true,
  draggable: false,
  progressStyle: {background: '#888E00'},
}
